<div id="main">
  <div class="inner">

    <div class="process-header">
      <h1 *ngIf="isPaymentProcessing">
        Oczekiwanie na potwierdzenie płatności
      </h1>
      <h1 *ngIf="isPaymentCompleted">
        Płatność potwierdzona
      </h1>
      <h1 *ngIf="isPaymentFailed">
        Płatność nie powiodła się
      </h1>
      <h2 *ngIf="isPaymentProcessing">
        Weryfikujemy płatność. To zwykle trwa chwilę. Nie musisz odświeżać strony.
      </h2>
      <h2 *ngIf="isPaymentCompleted">
        Płatność została potwierdzona. Rozpoczęliśmy generowanie raportu.
      </h2>
      <h2 *ngIf="isPaymentFailed">
        Płatność została przerwana albo zakończyła się błędem. Możesz spróbować ponownie.
      </h2>

    </div>

    <div class="process-content">


      <section class="header-box">

        <div class="header-box__main">
          <div *ngIf="isPaymentFailed"class="check-icon check-icon__error" aria-hidden="true">✕</div>
          <div *ngIf="isPaymentCompleted" class="check-icon" aria-hidden="true">✓</div>
          <div *ngIf="isPaymentProcessing" class="check-icon check-icon__processing" aria-hidden="true">↻</div>


          <div>
            <h2 *ngIf="isPaymentFailed">Płatność nie została zakończona</h2>
            <h2 *ngIf="isPaymentCompleted">Dziękujemy za zamówienie</h2>
            <h2 *ngIf="isPaymentProcessing">Oczekujemy na potwierdzenie płatności</h2>


            <p *ngIf="isPaymentFailed">Zamówienie nie może zostać zrealizowane, ponieważ płatność została przerwana albo zakończyła się błędem.</p>
            <p *ngIf="isPaymentCompleted">Nie musisz odświeżać tej strony. Raport zostanie wygenerowany automatycznie, a link otrzymasz
              e-mailem.</p>
            <p *ngIf="isPaymentProcessing">Weryfikujemy płatność. To zwykle trwa chwilę. Nie musisz odświeżać strony.</p>


          </div>
        </div>

        <div class="header-box__statuses">

          <div class="header-box__status-box">
            <strong>Status płatności: </strong>
            <span
              *ngIf="order?.payment?.status === 'COMPLETED'"
              class="badge badge-success u-margin-left-20">{{ order?.payment?.status | paymentStatus }}
            </span>
            <span
              *ngIf="order?.payment?.status === 'FAILED'
                                    || order?.payment?.status === 'CANCELED'"
              class="badge badge-warning u-margin-left-20">{{ order?.payment?.status | paymentStatus }}
            </span>
            <span
              *ngIf="order?.payment?.status !== 'FAILED'
                                    && order?.payment?.status !== 'CANCELED'
                                    && order?.payment?.status !== 'COMPLETED'"
              class="badge badge-danger u-margin-left-20">{{ order?.payment?.status | paymentStatus }}
            </span>
          </div>

          <div class="header-box__status-box">
            <strong>Status raportu: </strong>
            <span
              *ngIf="order?.report?.status === 'PROCESSED'"
              class="badge badge-success u-margin-left-20">{{ order?.report?.status | reportStatus }}
            </span>
            <span
              *ngIf="order?.report?.status && order?.report?.status !== 'PROCESSED'"
              class="badge badge-warning u-margin-left-20">{{ order?.report?.status | reportStatus }}
            </span>
            <span
              *ngIf="!order?.report?.status"
              class="badge badge-warning u-margin-left-20">{{ order?.report?.status | reportStatus }}
            </span>
          </div>

        </div>
      </section>

      <section class="steps">
        <ol class="steps__list">
          <li class="steps__list-item steps__list-item--done">Zamówienie złożone</li>
          <li class="steps__list-item" [class.steps__list-item--done]="order?.payment?.status === 'COMPLETED'" [class.steps__list-item--error]="isPaymentFailed">Zamówienie opłacone</li>
          <li class="steps__list-item" [class.steps__list-item--done]="order?.report?.status === 'PROCESSING' || order?.report?.status === 'PROCESSED' || order?.report?.status === 'FAILED'">Przygotowanie raportu</li>
          <li class="steps__list-item" [class.steps__list-item--done]="order?.report?.status === 'PROCESSED'">Raport gotowy</li>
        </ol>
      </section>


      <section class="main-grid">
<!--          <div>-->
<!--            <article class="card">-->
<!--              <h3>Szczegóły usługi</h3>-->
<!--              <div class="service">-->
<!--                <div>-->
<!--                  <p class="service__name">{{ order?.product?.publicName }}</p>-->
<!--                  <p class="service__desc">{{ order?.product?.description }}</p>-->
<!--                  <p class="service__deseased">Dane osoby sprawdzanej: {{ order?.deceased?.name }} {{ order?.deceased?.lastName }}</p>-->
<!--                  <p class="service__deseased">PESEL: {{ order?.deceased?.peselNumber }}</p>-->
<!--                </div>-->
<!--                <div class="service__price">-->
<!--                  {{ order?.product?.price?.amount | price:order?.product?.price?.currency }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </article>-->

<!--            <article class="card">-->
<!--              <h3>Dane dostawy</h3>-->
<!--              <p>-->
<!--                <strong>{{ order?.client?.name }} {{ order?.client?.lastName }}</strong>-->
<!--                <br> Raport zostanie wysłany na adres <span class="email">{{ order?.client?.email }}</span>-->
<!--              </p>-->
<!--            </article>-->
<!--          </div>-->



            <section class="card">
              <h3>Zamówienie</h3>
              <div class="order">
                  <div class="order__row">
                    <span class="order__row-label">Numer zamówienia</span>
                    <span class="order__row-value">{{ order?.orderNumber?.toUpperCase() }}</span>
                  </div>

                <div class="order__row">
                  <span class="order__row-label">Data zamówienia</span>
                  <span class="order__row-value">{{ order?.createdAt | date: 'medium'}}</span>
                </div>

                <div class="order__row">
                  <span class="order__row-label">ID Płatności</span>
                  <span [title]="order?.payment?.paymentId?.toUpperCase()" class="order__row-value">{{ shortenPaymentId(order?.payment?.paymentId?.toUpperCase())}} </span>
                </div>
              </div>

            </section>
        <aside>
            <section class="card next-box">
              <h3>Co dalej?</h3>
              <p *ngIf="isPaymentFailed"> Płatność została przerwana albo zakończyła się błędem. Aby zamówić raport, wróć do strony głównej i spróbuj ponownie.</p>
              <p *ngIf="isPaymentCompleted">Po zakończeniu generowania raportu otrzymasz wiadomość z linkiem do pobrania.</p>



<!--              <p>Po zakończeniu generowania raportu otrzymasz wiadomość z linkiem do pobrania. Link powinien być dostępny tylko dla osoby, która złożyła zamówienie.</p>-->
              <div class="actions">
<!--                <button *ngIf="isPaymentFailed" class="cta primary">Zamów jeszcze raz</button>-->
                <button *ngIf="!isPaymentFailed && reportId" class="cta primary" [routerLink]="['/raport', reportId]">Zobacz raport</button>
                <button class="cta cta-white">Strona główna</button>
              </div>
            </section>

          </aside>

      </section>














<!--      <section class="status-box">-->
<!--        <div class="order-number"><strong>Numer zamówienia: </strong><span-->
<!--          class="u-margin-left-20">{{ order?.orderNumber?.toUpperCase() }}</span></div>-->

<!--        <div class="payment-id"><strong>Id płatności: </strong><span-->
<!--          class="u-margin-left-20">{{ order?.payment?.paymentId?.toUpperCase() }}</span></div>-->

<!--        <div class="u-grid-self-to-right payment-status status-box__item">-->
<!--          <strong>Status płatności: </strong>-->
<!--          <span-->
<!--            *ngIf="order?.payment?.status === 'COMPLETED'"-->
<!--            class="badge badge-success u-margin-left-20">{{ order?.payment?.status | paymentStatus }}-->
<!--          </span>-->

<!--          <span-->
<!--            *ngIf="order?.payment?.status === 'FAILED'-->
<!--                                    || order?.payment?.status === 'CANCELED'"-->
<!--            class="badge badge-warning u-margin-left-20">{{ order?.payment?.status | paymentStatus }}-->
<!--          </span>-->

<!--          <span-->
<!--            *ngIf="order?.payment?.status !== 'FAILED'-->
<!--                                    && order?.payment?.status !== 'CANCELED'-->
<!--                                    && order?.payment?.status !== 'COMPLETED'"-->
<!--            class="badge badge-danger u-margin-left-20">{{ order?.payment?.status | paymentStatus }}-->
<!--          </span>-->
<!--        </div>-->

<!--        <div class="order-date">-->
<!--          <strong>Data zamówienia: </strong><span-->
<!--          class="u-margin-left-20">{{ order?.createdAt | date: 'medium' }}</span>-->
<!--        </div>-->

<!--        <div class="u-grid-self-to-right report-status status-box__item">-->
<!--          <strong>Status raportu: </strong>-->

<!--          <span-->
<!--            *ngIf="order?.report?.status === 'PROCESSED'"-->
<!--            class="badge badge-success u-margin-left-20">{{ order?.report?.status | reportStatus }}-->
<!--            </span>-->

<!--          <span-->
<!--            *ngIf="order?.report?.status && order?.report?.status !== 'PROCESSED'"-->
<!--            class="badge badge-warning u-margin-left-20">{{ order?.report?.status | reportStatus }}-->
<!--            </span>-->

<!--          <span-->
<!--            *ngIf="!order?.report?.status"-->
<!--            class="badge badge-warning u-margin-left-20">{{ order?.report?.status | reportStatus }}-->
<!--            </span>-->

<!--        </div>-->

<!--      </section>-->

<!--      <section>-->
<!--        <div class="details-table">-->
<!--          <h3 class="details-table__header">USŁUGA</h3>-->
<!--          <h3 class="details-table__header align-r">CENA</h3>-->
<!--          <div>-->
<!--            <p class="info-box">-->
<!--              <strong class="product-name">{{ order?.product?.publicName }}</strong>-->
<!--              <br>{{ order?.product?.description }}-->
<!--              <br><br> <strong>{{ order?.deceased?.name }} {{ order?.deceased?.lastName }} <br>-->
<!--              PESEL: {{ order?.deceased?.peselNumber }}</strong>-->
<!--            </p>-->


<!--            <h3 class="info-box delivery">DANE DOSTAWY</h3>-->
<!--            <p class="info-box">-->
<!--              <strong>{{ order?.client?.name }} {{ order?.client?.lastName }}</strong>-->
<!--              <br>{{ order?.client?.email }}-->
<!--            </p>-->

<!--          </div>-->


<!--          <p class="align-r info-box">-->
<!--            <strong>{{ order?.product?.price?.amount | price:order?.product?.price?.currency }}</strong>-->
<!--          </p>-->

<!--        </div>-->
<!--      </section>-->

<!--      <section class="report-box">-->
<!--        <h3 class="info-box">RAPORT</h3>-->
<!--        <div class="report-box__content">-->
<!--          <strong>Kiedy raporty zostanie wygenerowany otrzymasz do niego link na wskazany adres e-mail.</strong>-->
<!--          &lt;!&ndash;          <p>Kiedy raporty zostanie wygenerowany otrzymasz do niego link na wskazany adres e-mail. Alternatywnie, możesz chwilkę poczekać na tej stronie i nacisnąć jeden z przycisków kiedy zrobią się aktywne.</p>&ndash;&gt;-->
<!--          &lt;!&ndash;          <div class="action-buttons">&ndash;&gt;-->
<!--          &lt;!&ndash;            <button [disabled]="order?.report?.status !== 'PROCESSED'" class="cta primary"&ndash;&gt;-->
<!--          &lt;!&ndash;                    [routerLink]="['/raport', reportId]">Zobacz raport&ndash;&gt;-->
<!--          &lt;!&ndash;            </button>&ndash;&gt;-->
<!--&lt;!&ndash;                      <button [disabled]="order?.report?.status !== 'PROCESSED'" class="cta primary icon-button download-btn"&ndash;&gt;-->
<!--&lt;!&ndash;                              (click)="downloadReportInPdf()">Pobierz raport <span class="download-icon"&ndash;&gt;-->
<!--&lt;!&ndash;                                                                                   aria-hidden="true"></span></button>&ndash;&gt;-->
<!--          &lt;!&ndash;          </div>&ndash;&gt;-->
<!--        </div>-->
<!--      </section>-->

    </div>
  </div>
</div>
